
  import { css } from 'lit';
  export const styles = css`:host{--ig-theme: indigo;--ig-theme-variant: light}`;
  